// ── Turnover Configuration contacts: save plumbing (pure) ────────────────────
// Bug fixed 2026-09-23: the page read the new row's ConfigID from
// result.Table1, but turnoverWrite returns { ResultSets: { Table1 } } — so a
// new row never learned its id and every later edit INSERTED another row
// (a name and its email ended up as two rows; "+ Add CC" left a blank row).

// The ConfigID sp_SaveTurnoverConfigContact returned, from any response shape.
export function savedConfigId(result) {
  const row = result?.ResultSets?.Table1?.[0] || result?.Table1?.[0] || null;
  const id = Number(row?.ConfigID);
  return Number.isInteger(id) && id > 0 ? id : null;
}

// Stable client-side identity for a row — survives the save that assigns its
// ConfigID, so React never remounts the inputs mid-edit.
export const rowKeyOf = (c) => c._key || (c.ConfigID ? `id-${c.ConfigID}` : `new-${c.GroupKey}-${c.RoleLabel}`);

export function withKeys(rows = []) {
  return (rows || []).map(c => ({ ...c, _key: rowKeyOf(c) }));
}

// A row that has never been saved and has nothing in it is not worth storing.
export const isBlank = (c) => !String(c?.Name || "").trim() && !String(c?.Email || "").trim();

export function contactPayload(c) {
  return {
    config_id: c.ConfigID ?? null,
    group_key: c.GroupKey,
    role_label: c.RoleLabel,
    name: c.Name || null,
    email: c.Email || null,
    display_order: c.DisplayOrder ?? 100,
  };
}

// Apply an edit to the list: update the row with this key, or add it (a
// placeholder row — e.g. an empty "To" — isn't in the list until first edit).
export function upsertRow(rows, key, patch, template) {
  const i = rows.findIndex(c => c._key === key);
  if (i >= 0) return rows.map(c => (c._key === key ? { ...c, ...patch } : c));
  return [...rows, { ...template, ...patch, _key: key }];
}

export function nextDisplayOrder(rows, groupKey) {
  const orders = (rows || []).filter(c => c.GroupKey === groupKey).map(c => Number(c.DisplayOrder) || 0);
  return (orders.length ? Math.max(...orders) : 0) + 10;
}
